import { Component, OnInit, ViewChild, ElementRef, Optional, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatCheckboxChange, MatCheckbox } from '@angular/material/checkbox';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { TracingPlanTaskObservation } from '../../../../models/tracing-plan-task-observation';
import { ValidateBlankSpaces } from '../../common/evaluation-score-page/customValidators/evaluation-customValidator';
import { ThirdPartyEvaluationFormItemFile } from '../../../../models/thirdparty-evaluation-form-item-file';
import { AuthService } from '../../../../core/auth/_services/auth.service';
import { FileService } from '../../../../services/file.service';
import { saveAs } from 'file-saver';
import { TracingPlanService } from '../../../../services/tracing-plan.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DecimalPipe } from '@angular/common';
import { ExternalRequestManagerService } from '../../../../services/external-request-manager.service';
import { TracingPlanTaskDetail } from '../../../../models/tracing-plan-task-detail';
import { BehaviorSubject, forkJoin, Observable, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { StringFormatPipe } from '../../../../core/_base/layout/pipes/string-format.pipe';
import { NotificationService } from '../../../../services/notification.service';
import { ConfirmationDialogComponent } from '../../../../views/models/common-dialogs/confirmation-dialog/confirmation-dialog.component';
import { FollowUpResponseEnum } from '../../../../models/tracing-plan-task-item';
import { finalize, map, switchMap } from 'rxjs/operators';
import { FollowUpTaskFormDto, ThirdPartyFollowUpTaskExternalDto, ThirdPartyFollowUpTaskFormItem, ThirdPartyFollowUpTaskStatusEnum } from '../../../../models/thirdparty-tracing-tasks/thirdparty-tracing-task-external';
import { createEvaluationForm } from '../../../../utils/thirdparty-followup-task-form-builder';
import { ThirdpartyTaskConversation, ThirdpartyTaskConversationItem, ThirdpartyTaskFormConversationItem } from '../../../../models/thirdparty-tracing-tasks/conversations';
import { ThirdpartyConversationService } from '../../../../services/thirdparty-conversation.service';
import { FileStorageTypes } from '@app/enums/file-storage-types.enum';

@Component({
  selector: 'app-tracing-plan-task',
  templateUrl: './tracing-plan-task.component.html',
  styleUrls: ['./tracing-plan-task.component.scss']
})
export class TracingPlanTaskComponent implements OnInit {
  pageLoading$: BehaviorSubject<boolean>;
  _requiredApiRequests$: BehaviorSubject<Observable<any>[]>;

  thirdPartyFollowUpTaskFormId: number;
  taskId: number = 0;
  subTaskId: number = 0;
  taskDetail$: BehaviorSubject<TracingPlanTaskDetail>;

  taskForm: FormGroup;
  inputMaxLength: number = 255;

  dataSourceObservations: MatTableDataSource<TracingPlanTaskObservation>;
  dataSourceFilesCreate = new MatTableDataSource<ThirdPartyEvaluationFormItemFile>([]);

  initProgressPercentage: number = 0;

  userFiles;
  taskType;
  templates;
  formtTaskId;

  displayedObservationColumns: string[] = [
    'createDate',
    'description',
    'actions'
  ];

  displayedFilesColumns: string[] = [
    'icon',
    'name',
    'type',
    'size',
    'action'
  ];
  readOnly: boolean;
  followupTaskForm: FollowUpTaskFormDto;
  evaluationForm: FormGroup;
  thirdpartyFollowupTaskState: ThirdPartyFollowUpTaskStatusEnum;

  thirdpartyFollowUpConversationClass = ThirdpartyTaskConversationItem;
  thirdpartyFollowUpFormConversationClass = ThirdpartyTaskFormConversationItem;
  enqueuedNewFormMessages: ThirdpartyTaskConversationItem[] = [];
  conversations: ThirdpartyTaskConversation;
  thirdPartyFollowUpTaskFormItems: ThirdPartyFollowUpTaskFormItem[];

  /* #region Required Requests */
  addRequiredApiRequest(request: Observable<any>) {
    var requests = this._requiredApiRequests$.getValue() || [];
    requests.push(request);
    this._requiredApiRequests$.next(requests);
  }

  removeCompletedRequest(request: Observable<any>) {
    var requests = this._requiredApiRequests$.getValue();
    var index = requests.indexOf(request);
    requests.splice(index, 1);
    this._requiredApiRequests$.next(requests);
  }

  private checkRequestsOnDone() {
    // Check all required api request have finished
    this._requiredApiRequests$.subscribe(x => {
      var requests = this._requiredApiRequests$.getValue();
      if (requests == null) {
        return;
      }

      if (requests.length == 0) {
        this.pageLoading$.next(false);
      }
      else if (requests.length > 0) {
        this.pageLoading$.next(true);
      }
    });
  }
  /* #endregion */

  @ViewChild('tableObservations') observationsTable: MatTable<any>;
  @ViewChild('completeCheck') completeCheck: MatCheckbox;

  constructor(
    private fb: FormBuilder,
    private _authService: AuthService,
    private _fileService: FileService,
    private _tracingPlanService: TracingPlanService,
    private router: Router,
    private route: ActivatedRoute,
    private _requestManagerService: ExternalRequestManagerService,
    private confirmationDialog: MatDialog,
    private translate: TranslateService,
    private decimalPipe: DecimalPipe,
    private stringFormat: StringFormatPipe,
    private notification: NotificationService,
    private conversationService: ThirdpartyConversationService,
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    private data: { id: number, subId: number, readOnly: boolean },
    private fileService: FileService,
  ) {
    this.taskDetail$ = new BehaviorSubject<TracingPlanTaskDetail>(new TracingPlanTaskDetail());
    this.pageLoading$ = new BehaviorSubject<boolean>(true);
    this._requiredApiRequests$ = new BehaviorSubject<Observable<any>[]>(null);
    if ((this.data && this.data.readOnly) || this.route.snapshot.queryParamMap.get('explore')) {
      this.readOnly = true;
    }
  }

  ngOnInit() {
    this.taskId = Number.parseInt(this.route.snapshot.paramMap.get('id')) || this.data.id;
    this.subTaskId = Number.parseInt(this.route.snapshot.paramMap.get('subid') ? this.route.snapshot.paramMap.get('subid') : ('' + ((this.data && this.data.subId) || '0')));
    this.user = this._authService.currentUserPublic;
    //this._requestManagerService.requestPending$.subscribe(pending => this.pageLoading$.next(pending));
    this.checkRequestsOnDone();

    this.getTaskDetail();
    this.createTaskForm();
    this.maxSize = this._authService.maxUploadFileSize * this.oneMB;
  }

  private getTaskDetail(): void {
    const apiRequest: Observable<{ planDetail, thirdPartyEvaluation?: ThirdPartyFollowUpTaskExternalDto, conversations?: ThirdpartyTaskConversation }> = (
      (this.subTaskId) ? this._tracingPlanService.getPlanSubTaskDetail(this.subTaskId) : this._tracingPlanService.getPlanTaskDetail(this.taskId)
    ).pipe(
      switchMap(planDetail => {
        if (planDetail.followUpResponseEnum == FollowUpResponseEnum.ThirdPartyTask) {
          return this._tracingPlanService.getInternalTaskById(this.taskId)
            .pipe(
              switchMap(thirdPartyEvaluation => {
                return forkJoin({
                  conversations: this.conversationService.getAllConversationsForFollowUpTask(thirdPartyEvaluation.thirdPartyFollowUpTaskDto.thirdPartyFollowUpTaskFormDtos[0].id),
                  thirdPartyEvaluation: of(thirdPartyEvaluation),
                })
              }),
              map(({ thirdPartyEvaluation, conversations }) => ({
                planDetail,
                thirdPartyEvaluation,
                conversations,
              })
              ));
        } else {
          return of({ planDetail });
        }
      }),
    );
    this.addRequiredApiRequest(apiRequest);
    apiRequest.subscribe({
      next: ({ planDetail: res, thirdPartyEvaluation, conversations }) => {
        // console.log(res)
        // if (res.thirdPartyFollowUpTaskExternalDto) {
        //   this.userFiles = res.thirdPartyFollowUpTaskExternalDto.thirdPartyFollowUpTaskDto.thirdPartyFollowUpTaskFormDtos[0].fileDtos;
        // }

        // console.log(res.thirdPartyFollowUpTaskExternalDto.thirdPartyFollowUpTaskDto[0].fileDtos);
        // if (thirdPartyEvaluation) {
        // this._tracingPlanService.getInternalTaskById(this.taskId).subscribe(
        // task => {
        if (thirdPartyEvaluation) {
          this.conversations = conversations;
          this.taskType = thirdPartyEvaluation.followUpTasksThirdPartyBaseDto.followUpTaskFormDto.followUpTaskFormTypeEnum;
          this.templates = thirdPartyEvaluation.followUpTasksThirdPartyBaseDto.followUpTaskFormDto.files;
          this.formtTaskId = thirdPartyEvaluation.followUpTasksThirdPartyBaseDto.followUpTaskFormDto.id;
          this.userFiles = thirdPartyEvaluation.thirdPartyFollowUpTaskDto.thirdPartyFollowUpTaskFormDtos[0].fileDtos;
          this.thirdPartyFollowUpTaskFormId = thirdPartyEvaluation.thirdPartyFollowUpTaskDto.thirdPartyFollowUpTaskFormDtos[0].id;
          this.followupTaskForm = thirdPartyEvaluation.followUpTasksThirdPartyBaseDto.followUpTaskFormDto;
          this.thirdPartyFollowUpTaskFormItems = thirdPartyEvaluation.thirdPartyFollowUpTaskDto.thirdPartyFollowUpTaskFormDtos[0].thirdPartyFollowUpTaskFormItems;
          this.evaluationForm = createEvaluationForm(
            this.followupTaskForm.followUpTaskFormItems,
            50,
            200,
            10,
            true,
            thirdPartyEvaluation.thirdPartyFollowUpTaskDto.thirdPartyFollowUpTaskFormDtos[0].thirdPartyFollowUpTaskFormItems
          )
          this.thirdpartyFollowupTaskState = thirdPartyEvaluation.thirdPartyFollowUpTaskDto.thirdPartyFollowUpTaskStatusEnum | ThirdPartyFollowUpTaskStatusEnum.Pending;
        }
        // },
        // err => console.log(err)
        // );
        // }
        this.taskDetail$.next(res);
        this.initProgressPercentage = res.progressPercent;
        this.createTaskForm();
        this.dataSourceFilesCreate = new MatTableDataSource<ThirdPartyEvaluationFormItemFile>(res.fileWithItems.map(x => x.file));
      },
      complete: () => this.removeCompletedRequest(apiRequest),
      error: () => this.removeCompletedRequest(apiRequest)
    });
  }

  private createTaskForm(): void {
    let form = {};
    let validators = [];
    validators.push(Validators.required);
    validators.push(Validators.min(0));
    validators.push(Validators.max(100));
    validators.push(Validators.pattern(new RegExp('^[0-9]+$')));

    //Mark checkbox
    if (this.completeCheck) {
      this.completeCheck.checked = this.taskDetail$.getValue().progressPercent == 1;
    }

    form['progressPercent'] = [
      {
        value: this.decimalPipe.transform(this.taskDetail$.getValue().progressPercent * 100, '1.0-0'),
        disabled: false
      },
      validators
    ];

    validators = [];
    validators.push(Validators.maxLength(this.inputMaxLength));
    // Check for empty string
    validators.push(ValidateBlankSpaces);

    form['observation'] = [{ value: null, disabled: false }, validators];

    this.taskForm = this.fb.group(form);

    if (this.readOnly) {
      this.taskForm.disable();
    }

    this.dataSourceObservations = new MatTableDataSource<TracingPlanTaskObservation>(this.taskDetail$.getValue().tracingTaskObservation);
  }

  //#region  Obsevation CRUD
  addTaskObservation(): void {
    let observation: TracingPlanTaskObservation = new TracingPlanTaskObservation();

    observation.createDate = new Date();
    observation.description = this.taskForm.get('observation').value.trim();
    this.taskForm.get('observation').patchValue(null);

    this.dataSourceObservations.data.push(observation);
    this.observationsTable.renderRows();
  }

  deleteTaskObservation(element: TracingPlanTaskObservation): void {
    this.dataSourceObservations.data = this.dataSourceObservations.data.filter(x => x != element);
    this.observationsTable.renderRows();
  }
  //#endregion

  /* #region Files */
  user: any;
  filesQueue: number = 0;
  filesProcessed: number = 0;
  private oneMB: number = 1048576; // 1 MB
  private maxSize: number;
  // private maxSize: number = this._authService.maxUploadFileSize * this.oneMB;
  spinnerDisplay: boolean = false;
  @ViewChild('fileInput') fileInput: ElementRef = null;

  onFileUpload(files) {
    if (files && files.length > 0) {

      this.filesQueue += files.length;

      for (let index = 0; index < files.length; index++) {
        let selectedFile = files[index];

        // Verify allowed file extension
        if (!this._authService.allowedFileExtensions.includes(this.getFileExtension(selectedFile.name))) {
          this.filesProcessed++;
          this.showProcessedFiles();
          let msg = this.stringFormat.transform(this.translate.instant('FILEM.FILE_TYPE_NOT_SUPPORTED'), this.getFileExtension(selectedFile.name));
          this.notification.openSnackBar(msg);
        }
        // Verify Max file size
        else if (selectedFile.size >= this.maxSize) {
          this.filesProcessed++;
          this.showProcessedFiles();
          let msg = this.stringFormat.transform(this.translate.instant('FILEM.FILE_MAXSIZE'), selectedFile.name, this.formatBytes(this.maxSize));
          this.notification.openSnackBar(msg);
        }
        else {
          let reader = new FileReader();
          reader.readAsDataURL(selectedFile);
          reader.onload = () => {
            let newFile = new ThirdPartyEvaluationFormItemFile({
              id: 0,
              fileName: selectedFile.name,
              fileSize: selectedFile.size,
              file: (reader.result as string).split(',')[1],
              type: selectedFile.type,
              fileStorageType: FileStorageTypes.FollowUpTaskFormFiles
            });

            if (!newFile.file || newFile.file.length < 1) {
              this.filesProcessed++;
              this.showProcessedFiles();
              this.notification.openSnackBar(this.translate.instant('FILEM.FILE_EMPTY'));
            } else {
              this.postFileApi(newFile);
            }

          };
        }
      }
    } else {
      this.notification.openSnackBar(this.translate.instant('FILEM.NOFILE'));
    }

    if (this.fileInput && this.fileInput != undefined) {
      this.fileInput.nativeElement.value = null;
    }
  }

  showProcessedFiles() {
    if (this.filesQueue == this.filesProcessed) {
      this.clearFileUploadQueue();
    }
  }

  private clearFileUploadQueue() {
    this.filesQueue = this.filesProcessed = 0;
    this.spinnerDisplay = false;
  }

  postFileApi(file) {
    this.spinnerDisplay = true;
    this._fileService.postFile(file).subscribe({
      next: response => {
        file.id = response;
        this.dataSourceFilesCreate.data.push(file);
        this.dataSourceFilesCreate._updateChangeSubscription();

        this.filesProcessed++;
        this.showProcessedFiles();
      },
      error: err => {
        this.notification.openSnackBar(this.translate.instant('FILEM.ERROR'));
        this.clearFileUploadQueue();
      }
    })
  }

  getFileExtension(fileName: string): string {
    const fileParts = fileName.split('.');
    return fileParts[fileParts.length - 1];
  }

  getFileName(fileName: string): string {
    const fileParts = fileName.split('.');
    return fileParts[0];
  }

  //FileSize Format Func
  formatBytes(bytes) {
    const decimals = 2;
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  dropFile(file: ThirdPartyEvaluationFormItemFile) {
    this.dataSourceFilesCreate.data = this.dataSourceFilesCreate.data.filter(x => x.id != file.id);
    this.dataSourceFilesCreate._updateChangeSubscription();
    if (this.subTaskId) {
      this._fileService.deleteTracingSubTaskFile(file.id, this.subTaskId).subscribe({
        next: res => res
      })
    }
    else {
      this._fileService.deleteTracingTaskFile(file.id, this.taskId).subscribe({
        next: res => res
      })
    }
  }

  getFileById(item: ThirdPartyEvaluationFormItemFile) {
    if (item.id > 0) {
      this.spinnerDisplay = true;
      if (this.subTaskId) {
        this._fileService.downloadTracingSubTaskFile(item.id, this.subTaskId).subscribe(res => {
          this.downloadFile(res, item.fileName, res.type);
          this.spinnerDisplay = false;
        },
          (err) => {/*this._toast.error(err);*/ this.spinnerDisplay = false; })
      }
      else {
        this._fileService.downloadTracingTaskFile(item.id, this.taskId).subscribe(res => {
          this.downloadFile(res, item.fileName, res.type);
          this.spinnerDisplay = false;
        },
          (err) => {/*this._toast.error(err);*/ this.spinnerDisplay = false; })
      }

    } else {
      // this._toast.success(this._translateService.instant('FILEM.FILE-EXIST'));
    }
  }

  downloadFile(data: any, fileName: string, fileType: string) {
    const blob = new Blob([data], { type: fileType });
    saveAs(blob, fileName);
  }

  downloadAnswerFile(answerId: number) {
    return (fileId: number) => this.fileService.downloadThirdPartyFollowUpFile(answerId, fileId); 
  }
  /* #endregion */

  checkNewObservations(): boolean {
    return this.dataSourceObservations.data.filter(obs => !obs.tracingTaskObservationId).length > 0;
  }

  saveTaskCompletionProcess(): void {
    let taskDetail = this.taskDetail$.getValue();

    taskDetail.progressPercent = this.taskForm.get('progressPercent').value / 100;
    taskDetail.tracingTaskObservation = this.dataSourceObservations.data;
    taskDetail.tracingTaskObservation.forEach(x => x.tracingTaskId = (this.subTaskId) ? this.subTaskId : this.taskId);

    //Files
    taskDetail.files = this.dataSourceFilesCreate.data.map(x => {
      return {
        fileId: x.id,
        tracingTaskItemId: (this.subTaskId) ? this.subTaskId : this.taskId
      }
    });
    this.taskDetail$.next(taskDetail);

    // Check advance percentage progress
    if (this.initProgressPercentage != taskDetail.progressPercent && !this.checkNewObservations()) {
      var msg = this.translate.instant('TRACING_TASK_DETAIL.ALERTS.CHANGES_JUSTIFICATION');
      var initValue = this.decimalPipe.transform(this.initProgressPercentage * 100, '1.0-0');
      var newValue = this.decimalPipe.transform(this.taskForm.get('progressPercent').value, '1.0-0');

      msg = this.stringFormat.transform(msg, initValue, newValue);
      this.notification.openSnackBar(msg);
      return;
    }

    if (taskDetail.progressPercent == 1) {
      const dialogRef = this.confirmationDialog.open(ConfirmationDialogComponent, {
        width: '250px',
        data: this.translate.instant('TRACING_TASK_DETAIL.DIALOG.TASK_COMPLETED_CONFIRMATION')
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.updatePlanTask();
        }
      });
    }
    else {
      this.updatePlanTask();
    }
  }

  private updatePlanTask(): void {
    const conversations = this.getUnsavedConversations();

    const conversationRequest = (conversations.formConversations.length || conversations.itemsConversations.length) ?
      this.conversationService.saveAllConversationsForFollowUpTask(conversations) :
      of(null);


    const taskRequest = this._tracingPlanService.updatePlanTask(this.taskDetail$.getValue());

    const apiRequests = conversationRequest.pipe(
      switchMap(() => taskRequest),
    );

    this.addRequiredApiRequest(apiRequests);

    apiRequests
      .subscribe({
        next: res => this.router.navigate([`/tracing/plan-detail/${this.taskDetail$.getValue().tracingPlanId}`]),
        complete: () => this.removeCompletedRequest(apiRequests),
        error: () => this.removeCompletedRequest(apiRequests)
      });
  }

  cancelTaskCompletionProcess(): void {
    this.router.navigate([`/tracing/plan-detail/${this.taskDetail$.getValue().tracingPlanId}`]);
  }

  downloadTemplate(template) {
    this._tracingPlanService.downloadTemplate(this.formtTaskId, template.id).subscribe(
      res => {
        saveAs(res, template.fileName);
      },
      err => console.log(err)
    );
  }
  downloadUserFile(file) {
    this._tracingPlanService.downloadFile(this.thirdPartyFollowUpTaskFormId, file.id).subscribe(
      res => {
        saveAs(res, file.fileName);
      },
      err => console.log(err)
    );
  }


  // Conversations
  enqueueMessageItem(msgItem: ThirdpartyTaskConversationItem) {
    this.enqueuedNewFormMessages.push(msgItem);
  }

  dequeueMessageItem(msgItem: ThirdpartyTaskConversationItem) {
    this.enqueuedNewFormMessages = this.enqueuedNewFormMessages.filter(x => x.id !== msgItem.id);
  }

  private getUnsavedConversations(): ThirdpartyTaskConversation {
    // Setting evaluation data to msg item
    this.enqueuedNewFormMessages.forEach(msg => {
      msg.thirdPartyFollowUpTaskFormId = this.thirdPartyFollowUpTaskFormId;
      if (msg.isFormComment) {
        // msg.thirdPartyFollowUpTaskFormItemId = null;
      }
    });

    const unsavedConversations: ThirdpartyTaskConversation = {
      formConversations: this.enqueuedNewFormMessages.filter(msg => msg.isFormComment),
      itemsConversations: this.enqueuedNewFormMessages.filter(msg => !msg.isFormComment),
      taskFormId: this.thirdPartyFollowUpTaskFormId,
    };

    return unsavedConversations;
  }
  // end Conversations
}
